import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";
import { FileUploadI, MetodoPagamento } from "../utils";

export const putMetodoPagamento = async (params: {
  idAutonomo: string;
  metodoDePagamento: MetodoPagamento | null;
  nomeDoBanco: string | null;
  agencia: string | null;
  contaCorrente: string | null;
  cnpj: string | null;
  razaoSocial: string | null;
  enderecoFiscal: string | null;
  possuiCreciJuridico: boolean | null;
  arquivoCreciJuridico: FileUploadI | null;
  arquivoCNPJ: FileUploadI | null;
  authToken: string;
}): Promise<any> => {
  const url =
    "/api/alteracaoAutonomo/AlterarMetodoDePagamentoAlteracaoAutonomo";
  const { authToken, ...parameters } = params;
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.put(url, parameters, config);
  return response?.data;
};
